import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurant-week',
  templateUrl: './restaurant-week.component.html',
  styleUrls: ['./restaurant-week.component.scss']
})
export class RestaurantWeekComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/restaurant-week/restaurant-week.component.ts